/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.busy = {

  done() {
    $(".content-main").removeClass("busy");
    return NProgress.done();
  },

  start() {
    $(".content-main").addClass("busy");
    return NProgress.start();
  }
};